module.exports = __webpack_public_path__ + "static/media/GroundingTechniquesGREEK.8fbda631.vtt";